import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { IconEdit, IconTrash, IconZoomIn, IconEye } from "@tabler/icons-react";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatablePpsItem = (props) => {
  // console.log(props?.idRekomendasi);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: "Aksi",
      minWidth: "200px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          {/* <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-content">
              Aksi
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => props.handleDetailPps(row)}>
                Detail
              </Dropdown.Item>
              <Dropdown.Item onClick={() => props.handleEditPps(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={() => props.handleHapusPps(row.id)}>
                Hapus
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          <button
            className="btn btn-sm btn-outline-info"
            type="button"
            title="Detail Item PPS"
            onClick={() => props.handleDetailPps(row)}
          >
            <IconEye stroke={2} />
          </button>
          {props.role === "Kelompok Kerja" ||
            props.role === "Surveior Internal" ? (
            <>
              <button
                className="btn btn-sm btn-outline-warning"
                type="button"
                title="Edit Item PPS"
                onClick={() => props.handleEditPps(row)}
              >
                <IconEdit stroke={2} />
              </button>
              <button
                className="btn btn-sm btn-outline-danger"
                type="button"
                title="Hapus Item PPS"
                onClick={() => props.handleHapusPps(row.id)}
              >
                <IconTrash stroke={2} />
              </button>
            </>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: "Langkah Pemenuhan",
      minWidth: "250px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row.langkahPemenuhan}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    {
      name: "Metode Perbaikan",
      minWidth: "250px", // Set a minimum width for horizontal scroll
      // selector: (row) => row.metodePerbaikan,
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row.metodePerbaikan}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    {
      name: "Status Sinkron",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          {row.syncSpeakOnline === "Ya" ? (
            <span type="button" className="badge badge-success">
              Sync
            </span>
          ) : (
            <span type="button" className="badge badge-danger">
              Not Sync
            </span>
          )}
        </>
      ),
    },
    {
      name: "Kategori Perbaikan",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <span
          className="badge badge-light-primary"
        >
          {row.kategoriPerbaikan}
        </span>
      ),
    },
    {
      name: "Dokumen",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          type="button"
          title="Daftar Dokumen PPS"
          onClick={() => handleChangePage(`/pps-dokumen-item/${row.id}/${props?.idRekomendasi}`)}
        >
          <IconZoomIn stroke={2} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div style={{ overflowX: "auto", maxWidth: "1200px" }}>
        <DataTable
          columns={columns}
          data={props?.ppsitem}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search Item PPS"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatablePpsItem;
